/* This file is auto-generated, manual edits in this file will be overwritten! */
export const tKeys = {
    common: {
        more: 'common.more',
        continue: 'common.continue',
        'confirm-password': {
            placeholder: 'common.confirm-password.placeholder',
            label: 'common.confirm-password.label',
            email: {
                label: 'common.confirm-password.email.label',
            },
        },
        'verify-code': {
            'success-msg': 'common.verify-code.success-msg',
            'error-msg': 'common.verify-code.error-msg',
        },
        confirm: 'common.confirm',
        'enter-your-info': 'common.enter-your-info',
        password: {
            label: 'common.password.label',
            placeholder: 'common.password.placeholder',
        },
        'first-name': {
            label: 'common.first-name.label',
            placeholder: 'common.first-name.placeholder',
        },
        'last-name': {
            label: 'common.last-name.label',
            placeholder: 'common.last-name.placeholder',
        },
        'write-your-message': 'common.write-your-message',
        save: 'common.save',
        'unselect-all': 'common.unselect-all',
        'select-all': 'common.select-all',
        'published-by': 'common.published-by',
        'who-are-you-looking-for': 'common.who-are-you-looking-for',
        reset: 'common.reset',
        to: 'common.to',
        from: 'common.from',
        'insert-name': 'common.insert-name',
        create: 'common.create',
        name: {
            label: 'common.name.label',
            placeholder: 'common.name.placeholder',
        },
        'what-are-you-looking-for': 'common.what-are-you-looking-for',
        settings: 'common.settings',
        menu: 'common.menu',
        parameters: 'common.parameters',
        'need-help': 'common.need-help',
        active: 'common.active',
        completed: 'common.completed',
        order: 'common.order',
        'no-grouping': 'common.no-grouping',
        'group-by': 'common.group-by',
        verify: 'common.verify',
        nickname: {
            placeholder: 'common.nickname.placeholder',
        },
        file: 'common.file',
        add: 'common.add',
        camera: 'common.camera',
        download: 'common.download',
        created_on: 'common.created_on',
        filter_by: 'common.filter_by',
        cancel: 'common.cancel',
        repository: 'common.repository',
        filters: 'common.filters',
        title: 'common.title',
        description: {
            placeholder: 'common.description.placeholder',
            title: 'common.description.title',
        },
        start: 'common.start',
        end: 'common.end',
        you: 'common.you',
        remove_all: 'common.remove_all',
        assign_to: 'common.assign_to',
        delete: 'common.delete',
        agenda: 'common.agenda',
        question: 'common.question',
        votes: 'common.votes',
        yes: 'common.yes',
        publish: 'common.publish',
        edit: 'common.edit',
        optional: 'common.optional',
        tasks: 'common.tasks',
        due_date: 'common.due_date',
        until: 'common.until',
        sent_on: 'common.sent_on',
        placeholder: {
            subtitle: 'common.placeholder.subtitle',
        },
        invitations: 'common.invitations',
        all_members: 'common.all_members',
        send: 'common.send',
        board_admin: 'common.board_admin',
        board_member: 'common.board_member',
        user_profile: 'common.user_profile',
        member_role: 'common.member_role',
        messages: 'common.messages',
        status: 'common.status',
        today: 'common.today',
        no: 'common.no',
        no_opinion: 'common.no_opinion',
        search: 'common.search',
        event: 'common.event',
        post: 'common.post',
        message: 'common.message',
        assignedTo: 'common.assignedTo',
        voting: 'common.voting',
        workspaces: 'common.workspaces',
        recent_document: 'common.recent_document',
        updates: 'common.updates',
        your_conversations: 'common.your_conversations',
        welcome: 'common.welcome',
        group_members: 'common.group_members',
        to_sign: 'common.to_sign',
        signed: 'common.signed',
        not_signed: 'common.not_signed',
        and: 'common.and',
        private_chat: 'common.private_chat',
        generate: 'common.generate',
        loading: 'common.loading',
        logout: 'common.logout',
        added: 'common.added',
        date: 'common.date',
        abstain: 'common.abstain',
        no_due_date: 'common.no_due_date',
        participants: 'common.participants',
        in: 'common.in',
        fullscreen: 'common.fullscreen',
        'download-original': 'common.download-original',
        'download-annotations': 'common.download-annotations',
        apply: 'common.apply',
        lastUpdated: 'common.lastUpdated',
        between: 'common.between',
        NoFileName: 'common.NoFileName',
        'select-country': 'common.select-country',
        'welcome-to': 'common.welcome-to',
        'noticed-existing-phone': 'common.noticed-existing-phone',
        'link-email-info': 'common.link-email-info',
        'remove-email-later': 'common.remove-email-later',
        'link-email': 'common.link-email',
        confirmed: 'common.confirmed',
        sent: 'common.sent',
        relevance: 'common.relevance',
        recent: 'common.recent',
        on: {
            lowerCase: 'common.on.lowerCase',
        },
        'govrn-app': 'common.govrn-app',
        yesterday: 'common.yesterday',
        monday: 'common.monday',
        tuesday: 'common.tuesday',
        wednesday: 'common.wednesday',
        thursday: 'common.thursday',
        friday: 'common.friday',
        saturday: 'common.saturday',
        sunday: 'common.sunday',
        'week-ago': 'common.week-ago',
        'weeks-ago': 'common.weeks-ago',
        'second-ago': 'common.second-ago',
        'seconds-ago': 'common.seconds-ago',
        'minute-ago': 'common.minute-ago',
        'minutes-ago': 'common.minutes-ago',
        'hour-ago': 'common.hour-ago',
        'hours-ago': 'common.hours-ago',
        back: 'common.back',
        'logged-as': 'common.logged-as',
        close: 'common.close',
        trial: 'common.trial',
        'contact-us': 'common.contact-us',
        buy: 'common.buy',
        'update-app': 'common.update-app',
        update: 'common.update',
        updated: 'common.updated',
        error: 'common.error',
        install: 'common.install',
        register: 'common.register',
        'verify-and-sign-in': 'common.verify-and-sign-in',
        country: 'common.country',
        GovrnShared: 'common.GovrnShared',
        'this-week': 'common.this-week',
        'last-week': 'common.last-week',
        'this-quarter': 'common.this-quarter',
        other: 'common.other',
        'company-documents': 'common.company-documents',
        duplicate: 'common.duplicate',
        by: 'common.by',
        dateTimeToTimeAgo: {
            xSecondsAgo: 'common.dateTimeToTimeAgo.xSecondsAgo',
            aMinuteAgo: 'common.dateTimeToTimeAgo.aMinuteAgo',
            xMinutesAgo: 'common.dateTimeToTimeAgo.xMinutesAgo',
            anHourAgo: 'common.dateTimeToTimeAgo.anHourAgo',
            xHoursAgo: 'common.dateTimeToTimeAgo.xHoursAgo',
            yesterday: 'common.dateTimeToTimeAgo.yesterday',
            xDaysAgo: 'common.dateTimeToTimeAgo.xDaysAgo',
            aMonthAgo: 'common.dateTimeToTimeAgo.aMonthAgo',
            xMonthsAgo: 'common.dateTimeToTimeAgo.xMonthsAgo',
            aYearAgo: 'common.dateTimeToTimeAgo.aYearAgo',
            xYearsAgo: 'common.dateTimeToTimeAgo.xYearsAgo',
        },
        makeSignable: 'common.makeSignable',
        customActions: 'common.customActions',
        resolutions: 'common.resolutions',
        documentDate: 'common.documentDate',
        invited_by: 'common.invited_by',
        offline_repository: 'common.offline_repository',
        invitees: {
            add: {
                button: 'common.invitees.add.button',
            },
        },
        double_authentification: {
            title: 'common.double_authentification.title',
        },
        share: 'common.share',
        creation_date: 'common.creation_date',
        coming_soon: 'common.coming_soon',
        'download-pdf': 'common.download-pdf',
        'this-month': 'common.this-month',
        'this-year': 'common.this-year',
        search_members: 'common.search_members',
        history: 'common.history',
        board_observer: 'common.board_observer',
        roles: 'common.roles',
        platform_role: 'common.platform_role',
        board_role: 'common.board_role',
        choose_role: 'common.choose_role',
        no_role: 'common.no_role',
        timing: {
            title: 'common.timing.title',
        },
        decision: 'common.decision',
        informations: 'common.informations',
        discussion: 'common.discussion',
        see_document: 'common.see_document',
        no_presence: 'common.no_presence',
        issued_on: 'common.issued_on',
        groups: 'common.groups',
        '#_members': 'common.#_members',
        members_number: 'common.members_number',
        groups_number: 'common.groups_number',
        permissions: 'common.permissions',
        company: 'common.company',
        document_types: 'common.document_types',
        new: 'common.new',
        no_admin_privileges: 'common.no_admin_privileges',
        send_email: 'common.send_email',
        document_sources: 'common.document_sources',
        'reset-filter': 'common.reset-filter',
        'confirm-delete': 'common.confirm-delete',
        shared: 'common.shared',
        new_email: 'common.new_email',
        confirm_email: 'common.confirm_email',
        confirm_email_placeholder: 'common.confirm_email_placeholder',
        email_updated_success: 'common.email_updated_success',
    },
    'sign-in': {
        page: {
            title: 'sign-in.page.title',
            'identity-input': {
                label: 'sign-in.page.identity-input.label',
                placeholder: 'sign-in.page.identity-input.placeholder',
            },
            'password-input': {
                placeholder: 'sign-in.page.password-input.placeholder',
                forgot: 'sign-in.page.password-input.forgot',
                register: 'sign-in.page.password-input.register',
            },
        },
    },
    '': '',
    'sign-in-forgot-mail': {
        'email-address': {
            label: 'sign-in-forgot-mail.email-address.label',
            placeholder: 'sign-in-forgot-mail.email-address.placeholder',
            helper: 'sign-in-forgot-mail.email-address.helper',
        },
        success: {
            email_sent: 'sign-in-forgot-mail.success.email_sent',
            sms_sent: 'sign-in-forgot-mail.success.sms_sent',
        },
        errors: {
            email_not_sent: 'sign-in-forgot-mail.errors.email_not_sent',
        },
        'navigation-header': 'sign-in-forgot-mail.navigation-header',
    },
    'sign-in-forgot-new-password': {
        password: {
            placeholder: 'sign-in-forgot-new-password.password.placeholder',
        },
    },
    'sign-up': {
        page: {
            title: 'sign-up.page.title',
            'invitation-message': 'sign-up.page.invitation-message',
            'verification-message': 'sign-up.page.verification-message',
            'mobile-phone': {
                label: 'sign-up.page.mobile-phone.label',
            },
            'informative-text': 'sign-up.page.informative-text',
            'send-verification-code-button': 'sign-up.page.send-verification-code-button',
        },
        'invitation-expired': 'sign-up.invitation-expired',
    },
    'create-account': {
        'select-language': 'create-account.select-language',
        'select-timezone': 'create-account.select-timezone',
        'confirm-and-create-button': 'create-account.confirm-and-create-button',
    },
    'double-auth': {
        page: {
            title: 'double-auth.page.title',
            'send-code-message': {
                title: 'double-auth.page.send-code-message.title',
                phone: 'double-auth.page.send-code-message.phone',
            },
            'verify-code': 'double-auth.page.verify-code',
            'resend-code': {
                title: 'double-auth.page.resend-code.title',
                error: 'double-auth.page.resend-code.error',
            },
            'code-not-received-after-2-minutes': 'double-auth.page.code-not-received-after-2-minutes',
            'code-resent': 'double-auth.page.code-resent',
            login: {
                error: 'double-auth.page.login.error',
            },
        },
    },
    'create-password': {
        'navigation-header': 'create-password.navigation-header',
    },
    'choose-country': {
        'navigation-header': 'choose-country.navigation-header',
        search: {
            placeholder: 'choose-country.search.placeholder',
        },
    },
    home: {
        feed: {
            'create-post': {
                'post-button': 'home.feed.create-post.post-button',
                gallery: 'home.feed.create-post.gallery',
                files: 'home.feed.create-post.files',
                poll: 'home.feed.create-post.poll',
            },
            filter: {
                filters: 'home.feed.filter.filters',
                'custom-oeriods': {
                    title: 'home.feed.filter.custom-oeriods.title',
                },
                'apply-filter': 'home.feed.filter.apply-filter',
            },
            'navigation-title': 'home.feed.navigation-title',
            post: {
                insightful: 'home.feed.post.insightful',
            },
            'add-file': 'home.feed.add-file',
            'add-poll': 'home.feed.add-poll',
        },
        tasks: {
            'last-updated-first': 'home.tasks.last-updated-first',
            'last-updated-last': 'home.tasks.last-updated-last',
            alpha: {
                normal: 'home.tasks.alpha.normal',
                inverse: 'home.tasks.alpha.inverse',
            },
            'by-event': 'home.tasks.by-event',
            'by-event-type': 'home.tasks.by-event-type',
            'by-due-date': 'home.tasks.by-due-date',
            'by-assignee': 'home.tasks.by-assignee',
            'by-creator': 'home.tasks.by-creator',
            placeholder: {
                title: 'home.tasks.placeholder.title',
                subTitle: 'home.tasks.placeholder.subTitle',
            },
            completed: {
                placeholder: {
                    subTitle: 'home.tasks.completed.placeholder.subTitle',
                },
            },
        },
        more: {
            create_document_modal: {
                upload_a_file: 'home.more.create_document_modal.upload_a_file',
                upload_a_picture: 'home.more.create_document_modal.upload_a_picture',
                use_camera: 'home.more.create_document_modal.use_camera',
            },
            repository: {
                create_document: {
                    title: 'home.more.repository.create_document.title',
                    selected_file_type: {
                        title: 'home.more.repository.create_document.selected_file_type.title',
                    },
                    optional_description: {
                        title: 'home.more.repository.create_document.optional_description.title',
                    },
                },
                filter: {
                    header: {
                        title: 'home.more.repository.filter.header.title',
                    },
                },
                upload_image: {
                    title: 'home.more.repository.upload_image.title',
                },
                placeholder: {
                    title: 'home.more.repository.placeholder.title',
                    subTitle: 'home.more.repository.placeholder.subTitle',
                },
                makeSignable: {
                    title: 'home.more.repository.makeSignable.title',
                },
                addVersionModal: {
                    title: 'home.more.repository.addVersionModal.title',
                    signatureWarning: 'home.more.repository.addVersionModal.signatureWarning',
                },
                addbutton: {
                    title: 'home.more.repository.addbutton.title',
                },
            },
            document: {
                'edit-document': {
                    title: 'home.more.document.edit-document.title',
                    'button-title': 'home.more.document.edit-document.button-title',
                    'extra-description': 'home.more.document.edit-document.extra-description',
                    'delete-button-title': 'home.more.document.edit-document.delete-button-title',
                },
                history: {
                    uploaded: 'home.more.document.history.uploaded',
                },
                signature: {
                    expired: 'home.more.document.signature.expired',
                    failed: 'home.more.document.signature.failed',
                    cancelled: {
                        date: 'home.more.document.signature.cancelled.date',
                    },
                    transaction: {
                        expired: 'home.more.document.signature.transaction.expired',
                        failed: 'home.more.document.signature.transaction.failed',
                    },
                    signed: {
                        date: 'home.more.document.signature.signed.date',
                    },
                    waiting: 'home.more.document.signature.waiting',
                },
                'signature-nothing': 'home.more.document.signature-nothing',
                shouldBeSigned: 'home.more.document.shouldBeSigned',
                upload: {
                    dragAndDrop: 'home.more.document.upload.dragAndDrop',
                },
            },
            offline_repository: {
                placeholder: {
                    subTitle: 'home.more.offline_repository.placeholder.subTitle',
                },
            },
            members: {
                addbutton: {
                    title: 'home.more.members.addbutton.title',
                },
            },
        },
        calendar: {
            card_event: {
                status: {
                    draft: 'home.calendar.card_event.status.draft',
                },
            },
            event_details: {
                information: {
                    presence: {
                        title: 'home.calendar.event_details.information.presence.title',
                        status: {
                            present: 'home.calendar.event_details.information.presence.status.present',
                            proxy: 'home.calendar.event_details.information.presence.status.proxy',
                            absent: 'home.calendar.event_details.information.presence.status.absent',
                            pending: 'home.calendar.event_details.information.presence.status.pending',
                            remote: 'home.calendar.event_details.information.presence.status.remote',
                        },
                    },
                    invitees: {
                        title: 'home.calendar.event_details.information.invitees.title',
                    },
                    no_invitees: {
                        title: 'home.calendar.event_details.information.no_invitees.title',
                        body_text: 'home.calendar.event_details.information.no_invitees.body_text',
                    },
                    presence_not_requested: 'home.calendar.event_details.information.presence_not_requested',
                },
                upload_proxy: {
                    title: 'home.calendar.event_details.upload_proxy.title',
                },
                proxy: {
                    title: 'home.calendar.event_details.proxy.title',
                    'download-template': 'home.calendar.event_details.proxy.download-template',
                    generate: 'home.calendar.event_details.proxy.generate',
                },
                invitees: {
                    status: {
                        title: 'home.calendar.event_details.invitees.status.title',
                    },
                },
                resolutions: 'home.calendar.event_details.resolutions',
            },
            save_event_in_calendar: 'home.calendar.save_event_in_calendar',
            error_event_in_calendar: 'home.calendar.error_event_in_calendar',
        },
        event: {
            proxy: {
                no_members_present: {
                    placeholder: 'home.event.proxy.no_members_present.placeholder',
                },
            },
        },
        navigation_bar: {
            feed: 'home.navigation_bar.feed',
            actions: 'home.navigation_bar.actions',
            calendar: 'home.navigation_bar.calendar',
            private_chat: 'home.navigation_bar.private_chat',
            ai_assist: 'home.navigation_bar.ai_assist',
        },
        messages: {
            navHeader: {
                title: 'home.messages.navHeader.title',
                button: {
                    title: 'home.messages.navHeader.button.title',
                },
            },
            chatbox: {
                button: {
                    title: 'home.messages.chatbox.button.title',
                },
            },
        },
        action: {
            button: {
                title: 'home.action.button.title',
            },
        },
    },
    tasks: {
        placeholder: {
            title: 'tasks.placeholder.title',
            subTitle: 'tasks.placeholder.subTitle',
        },
        grouping: {
            noGrouping: 'tasks.grouping.noGrouping',
            groupBy: 'tasks.grouping.groupBy',
        },
        filter: {
            active: 'tasks.filter.active',
            completed: 'tasks.filter.completed',
        },
        create_task: {
            new_task: 'tasks.create_task.new_task',
            define_date: 'tasks.create_task.define_date',
            assign_to: {
                assigned_members: 'tasks.create_task.assign_to.assigned_members',
                members: 'tasks.create_task.assign_to.members',
                assigned_member: 'tasks.create_task.assign_to.assigned_member',
            },
            edit_task: 'tasks.create_task.edit_task',
        },
        create_tasks: {
            description: {
                placeholder: 'tasks.create_tasks.description.placeholder',
            },
            title: {
                placeholder: 'tasks.create_tasks.title.placeholder',
            },
            question: {
                placeholder: 'tasks.create_tasks.question.placeholder',
            },
        },
        type: {
            READ: 'tasks.type.READ',
            RSVP: 'tasks.type.RSVP',
            PROXY: 'tasks.type.PROXY',
            SIGN: 'tasks.type.SIGN',
            ACTION: 'tasks.type.ACTION',
            SURVEYS: 'tasks.type.SURVEYS',
            VOTES: 'tasks.type.VOTES',
            POLL: 'tasks.type.POLL',
        },
        delete: {
            task: 'tasks.delete.task',
        },
        task_detail: {
            header: {
                title: 'tasks.task_detail.header.title',
            },
        },
        card: {
            dueDate: 'tasks.card.dueDate',
            eventName: 'tasks.card.eventName',
            assignedTo: 'tasks.card.assignedTo',
        },
        open: 'tasks.open',
        completed: 'tasks.completed',
        'proxy-document': 'tasks.proxy-document',
    },
    settings: {
        'manage-company-details': {
            'navigation-header': 'settings.manage-company-details.navigation-header',
            'company-name': {
                label: 'settings.manage-company-details.company-name.label',
            },
            'legal-name': {
                label: 'settings.manage-company-details.legal-name.label',
            },
            street: {
                label: 'settings.manage-company-details.street.label',
                placeholder: 'settings.manage-company-details.street.placeholder',
            },
            'zip-code': {
                label: 'settings.manage-company-details.zip-code.label',
                placeholder: 'settings.manage-company-details.zip-code.placeholder',
            },
            city: {
                label: 'settings.manage-company-details.city.label',
                placeholder: 'settings.manage-company-details.city.placeholder',
            },
            state: {
                label: 'settings.manage-company-details.state.label',
                placeholder: 'settings.manage-company-details.state.placeholder',
            },
            country: {
                label: 'settings.manage-company-details.country.label',
                placeholder: 'settings.manage-company-details.country.placeholder',
            },
            'post-mail': {
                label: 'settings.manage-company-details.post-mail.label',
                placeholder: 'settings.manage-company-details.post-mail.placeholder',
            },
            vat: {
                label: 'settings.manage-company-details.vat.label',
                placeholder: 'settings.manage-company-details.vat.placeholder',
            },
            'company-language': 'settings.manage-company-details.company-language',
            street2: {
                label: 'settings.manage-company-details.street2.label',
            },
            'legal-form': {
                label: 'settings.manage-company-details.legal-form.label',
            },
            'language-select': 'settings.manage-company-details.language-select',
        },
        'manage-events': {
            'add-event-type': {
                'navigation-header': 'settings.manage-events.add-event-type.navigation-header',
                name: 'settings.manage-events.add-event-type.name',
            },
            'modify-event-type': {
                'navigation-header': 'settings.manage-events.modify-event-type.navigation-header',
            },
            page: {
                'navigation-header': 'settings.manage-events.page.navigation-header',
            },
        },
        'manage-files': {
            'add-file-type': {
                'navigation-header': 'settings.manage-files.add-file-type.navigation-header',
                name: 'settings.manage-files.add-file-type.name',
            },
            'modify-file-type': {
                'navigation-header': 'settings.manage-files.modify-file-type.navigation-header',
            },
            page: {
                'navigation-header': 'settings.manage-files.page.navigation-header',
            },
        },
        page: {
            button: {
                'manage-events': 'settings.page.button.manage-events',
                'manage-files': 'settings.page.button.manage-files',
                'manage-company-details': 'settings.page.button.manage-company-details',
            },
        },
        'other-settings': {
            isFileDownloadAllowed: 'settings.other-settings.isFileDownloadAllowed',
            isOriginalFileDownloadAllowed: 'settings.other-settings.isOriginalFileDownloadAllowed',
            WatermarkSettingDescription: 'settings.other-settings.WatermarkSettingDescription',
            isWatermarkingEnabled: 'settings.other-settings.isWatermarkingEnabled',
            'navigation-header': 'settings.other-settings.navigation-header',
        },
        manage_file_types: {
            search_text_plural: 'settings.manage_file_types.search_text_plural',
            search_text: 'settings.manage_file_types.search_text',
        },
        event_item: {
            deleted: {
                success: 'settings.event_item.deleted.success',
            },
        },
        file_item: {
            deleted: {
                success: 'settings.file_item.deleted.success',
            },
        },
        board_role: {
            deleted: {
                success: 'settings.board_role.deleted.success',
            },
            modify: {
                title: 'settings.board_role.modify.title',
            },
        },
        file_type: {
            add: {
                button: 'settings.file_type.add.button',
            },
        },
        event_type: {
            add: {
                button: 'settings.event_type.add.button',
            },
        },
        board_roles: {
            add: {
                button: 'settings.board_roles.add.button',
            },
            manage: 'settings.board_roles.manage',
        },
    },
    more: {
        page: {
            menu: {
                repository: {
                    menu_title: 'more.page.menu.repository.menu_title',
                    explanations: 'more.page.menu.repository.explanations',
                    description: 'more.page.menu.repository.description',
                    header: {
                        title: 'more.page.menu.repository.header.title',
                    },
                },
                'knowledge-base': {
                    menu_title: 'more.page.menu.knowledge-base.menu_title',
                    info: 'more.page.menu.knowledge-base.info',
                },
                members: {
                    menu_title: 'more.page.menu.members.menu_title',
                    explanations: 'more.page.menu.members.explanations',
                    'member-detail-role': 'more.page.menu.members.member-detail-role',
                    'member-detail-date': 'more.page.menu.members.member-detail-date',
                    'member-detail-since': 'more.page.menu.members.member-detail-since',
                    'member-detail-linkedIn': 'more.page.menu.members.member-detail-linkedIn',
                    'member-detail-no-biography': 'more.page.menu.members.member-detail-no-biography',
                    'member-detail-until': 'more.page.menu.members.member-detail-until',
                },
                knowledge_base: {
                    explanations: 'more.page.menu.knowledge_base.explanations',
                },
                parameters: {
                    explanations: 'more.page.menu.parameters.explanations',
                },
                repository_explanations: 'more.page.menu.repository_explanations',
                members_explanations: 'more.page.menu.members_explanations',
                'resolution-log': 'more.page.menu.resolution-log',
                'board-evaluation': 'more.page.menu.board-evaluation',
            },
            parameters: {
                'group-settings': 'more.page.parameters.group-settings',
                group_settings: {
                    explanation: 'more.page.parameters.group_settings.explanation',
                },
            },
            'need-help': {
                helpdesk: 'more.page.need-help.helpdesk',
            },
            leaving: {
                title: 'more.page.leaving.title',
                disconnect: 'more.page.leaving.disconnect',
            },
            helpdesk: {
                explanation: 'more.page.helpdesk.explanation',
            },
        },
    },
    profile: {
        'user-profile': {
            mail: {
                'verify-code': {
                    'navigation-header': 'profile.user-profile.mail.verify-code.navigation-header',
                    'enter-code-msg': 'profile.user-profile.mail.verify-code.enter-code-msg',
                },
                'confirm-code-msg': 'profile.user-profile.mail.confirm-code-msg',
            },
            'email-address': {
                'navigation-header': 'profile.user-profile.email-address.navigation-header',
                'address-mails': 'profile.user-profile.email-address.address-mails',
                'log-in-options': 'profile.user-profile.email-address.log-in-options',
                'face-id-msg': 'profile.user-profile.email-address.face-id-msg',
                title: 'profile.user-profile.email-address.title',
            },
            mobile: {
                'verify-code': {
                    'enter-code-msg': 'profile.user-profile.mobile.verify-code.enter-code-msg',
                    "navigation-header'": "profile.user-profile.mobile.verify-code.navigation-header'",
                },
                'navigation-header': 'profile.user-profile.mobile.navigation-header',
                form: {
                    label: 'profile.user-profile.mobile.form.label',
                    'current-phone': 'profile.user-profile.mobile.form.current-phone',
                },
                send: {
                    validation: {
                        code: 'profile.user-profile.mobile.send.validation.code',
                    },
                },
            },
            myinfo: {
                'my-information': 'profile.user-profile.myinfo.my-information',
                'your-name': 'profile.user-profile.myinfo.your-name',
                bio: {
                    label: 'profile.user-profile.myinfo.bio.label',
                    placeholder: 'profile.user-profile.myinfo.bio.placeholder',
                },
                'app-lang': 'profile.user-profile.myinfo.app-lang',
                'time-zone': 'profile.user-profile.myinfo.time-zone',
                'app-lang-select': 'profile.user-profile.myinfo.app-lang-select',
                linkedIn: 'profile.user-profile.myinfo.linkedIn',
                'time-zone-select': 'profile.user-profile.myinfo.time-zone-select',
                'your-first-name': 'profile.user-profile.myinfo.your-first-name',
                'your-last-name': 'profile.user-profile.myinfo.your-last-name',
                'your-nickname': 'profile.user-profile.myinfo.your-nickname',
            },
            notif: {
                'navigation-header': 'profile.user-profile.notif.navigation-header',
            },
            password: {
                form: {
                    label: 'profile.user-profile.password.form.label',
                    placeholder: 'profile.user-profile.password.form.placeholder',
                    title: 'profile.user-profile.password.form.title',
                },
                change: {
                    label: 'profile.user-profile.password.change.label',
                    placeholder: 'profile.user-profile.password.change.placeholder',
                    confirm: 'profile.user-profile.password.change.confirm',
                },
                updated: 'profile.user-profile.password.updated',
            },
            'select-language': 'profile.user-profile.select-language',
            'select-timezone': {
                'navigation-header': 'profile.user-profile.select-timezone.navigation-header',
                placeholder: 'profile.user-profile.select-timezone.placeholder',
            },
            'file-extension': {
                error: 'profile.user-profile.file-extension.error',
            },
            'update-person': {
                error: 'profile.user-profile.update-person.error',
            },
            'my-information': 'profile.user-profile.my-information',
            'mobile-phone': {
                title: 'profile.user-profile.mobile-phone.title',
                updated: 'profile.user-profile.mobile-phone.updated',
            },
            notification: {
                title: 'profile.user-profile.notification.title',
                saved: 'profile.user-profile.notification.saved',
            },
            page: {
                'navigation-header': 'profile.user-profile.page.navigation-header',
                'modify-photo': 'profile.user-profile.page.modify-photo',
            },
            form: {
                'current-password': 'profile.user-profile.form.current-password',
                'new-password': 'profile.user-profile.form.new-password',
            },
            saved: 'profile.user-profile.saved',
            logout: {
                title: 'profile.user-profile.logout.title',
            },
        },
        user_profile: {
            mobile: {
                error: 'profile.user_profile.mobile.error',
                verify_code: {
                    navigation_header: 'profile.user_profile.mobile.verify_code.navigation_header',
                    enter_code_msg: 'profile.user_profile.mobile.verify_code.enter_code_msg',
                },
            },
            update_phone_number: {
                success: 'profile.user_profile.update_phone_number.success',
            },
            member_since: 'profile.user_profile.member_since',
        },
        picture: {
            edit: 'profile.picture.edit',
        },
    },
    taskDetail: {
        downloadWithAnnotations: 'taskDetail.downloadWithAnnotations',
        fullScreen: 'taskDetail.fullScreen',
        post: 'taskDetail.post',
        shareModal: {
            title: 'taskDetail.shareModal.title',
        },
        taskCard: {
            createdBy: 'taskDetail.taskCard.createdBy',
            assignTo: 'taskDetail.taskCard.assignTo',
            assignToMe: 'taskDetail.taskCard.assignToMe',
            createdByMe: 'taskDetail.taskCard.createdByMe',
        },
        assignTo: 'taskDetail.assignTo',
    },
    search: {
        people: {
            placeholder: 'search.people.placeholder',
        },
        filter: {
            FILE: 'search.filter.FILE',
            FILE_plural: 'search.filter.FILE_plural',
            EVENT: 'search.filter.EVENT',
            EVENT_plural: 'search.filter.EVENT_plural',
            MESSAGE: 'search.filter.MESSAGE',
            MESSAGE_plural: 'search.filter.MESSAGE_plural',
            POST: 'search.filter.POST',
            POST_plural: 'search.filter.POST_plural',
            'content-types': 'search.filter.content-types',
        },
        totalResult: 'search.totalResult',
        global: {
            placeholder: 'search.global.placeholder',
        },
        eventCard: {
            date: 'search.eventCard.date',
        },
        placeholder: {
            no_results: {
                subtitle: 'search.placeholder.no_results.subtitle',
                title: 'search.placeholder.no_results.title',
            },
            no_search_terms: {
                title: 'search.placeholder.no_search_terms.title',
                subtitle: 'search.placeholder.no_search_terms.subtitle',
            },
        },
        input: {
            placeholder: {
                title: 'search.input.placeholder.title',
            },
        },
    },
    newsFeed: {
        cardActiveTasks: {
            title: 'newsFeed.cardActiveTasks.title',
            allTasks: {
                title: 'newsFeed.cardActiveTasks.allTasks.title',
            },
        },
        cardNextEvent: {
            title: 'newsFeed.cardNextEvent.title',
        },
        cardPoll: {
            seePollResults: 'newsFeed.cardPoll.seePollResults',
        },
        action: {
            'completion-progress': {
                info: 'newsFeed.action.completion-progress.info',
            },
        },
    },
    disconnectModal: {
        inviteMembersCTA: {
            label: 'disconnectModal.inviteMembersCTA.label',
        },
        LeaveCTA: {
            label: 'disconnectModal.LeaveCTA.label',
        },
    },
    documentDetails: {
        documentVersion: {
            createdOn: 'documentDetails.documentVersion.createdOn',
            updatedOn: 'documentDetails.documentVersion.updatedOn',
        },
        boardMinutes: 'documentDetails.boardMinutes',
        description: {
            none: 'documentDetails.description.none',
        },
        'older-version': 'documentDetails.older-version',
        'the-latest-version': 'documentDetails.the-latest-version',
        addVersion: 'documentDetails.addVersion',
    },
    document: {
        card: {
            update: {
                date: 'document.card.update.date',
            },
        },
        shareModal: {
            title: 'document.shareModal.title',
            placeholder: 'document.shareModal.placeholder',
        },
        share: {
            success: 'document.share.success',
        },
        moreModal: {
            button: {
                disable: 'document.moreModal.button.disable',
                enable: 'document.moreModal.button.enable',
                edit: 'document.moreModal.button.edit',
            },
        },
        disable_offline: 'document.disable_offline',
        details: {
            file_type: 'document.details.file_type',
            linked_event: 'document.details.linked_event',
            history: {
                coming_soon: 'document.details.history.coming_soon',
            },
            signers: {
                title: 'document.details.signers.title',
                add: 'document.details.signers.add',
            },
            sign: {
                alert: {
                    title: 'document.details.sign.alert.title',
                    subtitle: 'document.details.sign.alert.subtitle',
                    button: 'document.details.sign.alert.button',
                },
            },
            upload: 'document.details.upload',
        },
        permissions: {
            file: {
                title: 'document.permissions.file.title',
            },
            event: {
                title: 'document.permissions.event.title',
            },
            search: 'document.permissions.search',
        },
    },
    filter: {
        order: {
            last_updated_first: 'filter.order.last_updated_first',
            last_updated_last: 'filter.order.last_updated_last',
            alphabetically: {
                desc: 'filter.order.alphabetically.desc',
                asc: 'filter.order.alphabetically.asc',
            },
            last_started_last: 'filter.order.last_started_last',
            last_started_first: 'filter.order.last_started_first',
            recent_document_date_first: 'filter.order.recent_document_date_first',
            recent_document_date_last: 'filter.order.recent_document_date_last',
        },
        order_by: {
            task: {
                by_event: 'filter.order_by.task.by_event',
                by_event_type: 'filter.order_by.task.by_event_type',
                by_due_date: 'filter.order_by.task.by_due_date',
                by_assignee: 'filter.order_by.task.by_assignee',
                by_creator: 'filter.order_by.task.by_creator',
            },
            document: {
                all_documents: 'filter.order_by.document.all_documents',
                by_file_type: 'filter.order_by.document.by_file_type',
                by_event: 'filter.order_by.document.by_event',
                by_date: 'filter.order_by.document.by_date',
                by_event_type: 'filter.order_by.document.by_event_type',
            },
        },
        document_source: {
            from_event: 'filter.document_source.from_event',
            general_documents: 'filter.document_source.general_documents',
            all: 'filter.document_source.all',
            to_sign: 'filter.document_source.to_sign',
        },
    },
    knowledgeBase: {
        placeholder: {
            title: 'knowledgeBase.placeholder.title',
            subtitle: 'knowledgeBase.placeholder.subtitle',
        },
        filter: {
            language: 'knowledgeBase.filter.language',
        },
    },
    news_feed: {
        period_time: {
            title: 'news_feed.period_time.title',
        },
        no_post: {
            placeholder: {
                title: 'news_feed.no_post.placeholder.title',
                subtitle: 'news_feed.no_post.placeholder.subtitle',
            },
        },
        edit_post: 'news_feed.edit_post',
        no_post_filtered: {
            placeholder: {
                title: 'news_feed.no_post_filtered.placeholder.title',
                subtitle: 'news_feed.no_post_filtered.placeholder.subtitle',
            },
        },
        delete_post: {
            title: 'news_feed.delete_post.title',
            confirm: 'news_feed.delete_post.confirm',
        },
        'create-post': {
            'write-your-message': 'news_feed.create-post.write-your-message',
            'upload-file': 'news_feed.create-post.upload-file',
        },
        'delete-file': 'news_feed.delete-file',
        'edit-post': {
            'write-your-message': 'news_feed.edit-post.write-your-message',
        },
        discuss_post: 'news_feed.discuss_post',
    },
    calendar: {
        createEvent: {
            title: 'calendar.createEvent.title',
            location: {
                placeholder: 'calendar.createEvent.location.placeholder',
            },
            locationUrl: {
                placeholder: 'calendar.createEvent.locationUrl.placeholder',
            },
            eventType: {
                title: 'calendar.createEvent.eventType.title',
            },
            invitees: {
                title: 'calendar.createEvent.invitees.title',
            },
            timeZone: {
                title: 'calendar.createEvent.timeZone.title',
            },
            eventDates: {
                title: 'calendar.createEvent.eventDates.title',
            },
            'invitees-select-all': 'calendar.createEvent.invitees-select-all',
        },
        placeholder: {
            title: 'calendar.placeholder.title',
            subTitle: 'calendar.placeholder.subTitle',
        },
        filter: {
            event_not_invited: 'calendar.filter.event_not_invited',
            'event-types': 'calendar.filter.event-types',
        },
        agenda: {
            item: {
                totalVotes: 'calendar.agenda.item.totalVotes',
                seeResults: 'calendar.agenda.item.seeResults',
                edit: 'calendar.agenda.item.edit',
                add: 'calendar.agenda.item.add',
                addVoting: 'calendar.agenda.item.addVoting',
                question: {
                    subtitle: 'calendar.agenda.item.question.subtitle',
                },
                isAnonymous: {
                    title: 'calendar.agenda.item.isAnonymous.title',
                    subtitle: 'calendar.agenda.item.isAnonymous.subtitle',
                },
                terminateVote: 'calendar.agenda.item.terminateVote',
                deleteVoting: 'calendar.agenda.item.deleteVoting',
                delete: {
                    title: 'calendar.agenda.item.delete.title',
                    confirm: 'calendar.agenda.item.delete.confirm',
                },
                reopenVote: 'calendar.agenda.item.reopenVote',
                proxyVoting: 'calendar.agenda.item.proxyVoting',
                proxy: {
                    voted: 'calendar.agenda.item.proxy.voted',
                },
                terminated: 'calendar.agenda.item.terminated',
                anonymous: 'calendar.agenda.item.anonymous',
                'proxy-info': 'calendar.agenda.item.proxy-info',
                notification_warning: 'calendar.agenda.item.notification_warning',
            },
            placeholder: {
                title: 'calendar.agenda.placeholder.title',
                subtitle: 'calendar.agenda.placeholder.subtitle',
                button: 'calendar.agenda.placeholder.button',
                subtitle_invitees: 'calendar.agenda.placeholder.subtitle_invitees',
            },
        },
        editEvent: {
            title: 'calendar.editEvent.title',
            deleteEvent: 'calendar.editEvent.deleteEvent',
            timeZone: {
                title: 'calendar.editEvent.timeZone.title',
            },
            'invitees-select-all': 'calendar.editEvent.invitees-select-all',
        },
        files: {
            placeholder: {
                title: 'calendar.files.placeholder.title',
                subTitle: 'calendar.files.placeholder.subTitle',
                subTitle_invitees: 'calendar.files.placeholder.subTitle_invitees',
            },
            add_a_file: 'calendar.files.add_a_file',
        },
        resolution: {
            placeholder: {
                title: 'calendar.resolution.placeholder.title',
                subTitle: 'calendar.resolution.placeholder.subTitle',
                subTitle_invitees: 'calendar.resolution.placeholder.subTitle_invitees',
            },
            add_a_resolution: 'calendar.resolution.add_a_resolution',
            edit_a_resolution: 'calendar.resolution.edit_a_resolution',
            create: {
                placeholder: {
                    title: 'calendar.resolution.create.placeholder.title',
                    description: 'calendar.resolution.create.placeholder.description',
                },
                description: 'calendar.resolution.create.description',
            },
            delete: 'calendar.resolution.delete',
        },
        tasks: {
            placeholder: {
                title: 'calendar.tasks.placeholder.title',
                subTitle: 'calendar.tasks.placeholder.subTitle',
                subTitle_invitees: 'calendar.tasks.placeholder.subTitle_invitees',
            },
            add_a_task: 'calendar.tasks.add_a_task',
        },
        eventDetail: {
            previewMinutes: {
                title: 'calendar.eventDetail.previewMinutes.title',
                helper: 'calendar.eventDetail.previewMinutes.helper',
            },
        },
        generateDocument: {
            header: 'calendar.generateDocument.header',
            selectLanguage: 'calendar.generateDocument.selectLanguage',
            signButton: 'calendar.generateDocument.signButton',
        },
        updateEvent: {
            locationUrl: {
                placeholder: 'calendar.updateEvent.locationUrl.placeholder',
            },
            location: {
                placeholder: 'calendar.updateEvent.location.placeholder',
            },
        },
        event: {
            completion: {
                title: 'calendar.event.completion.title',
                info: 'calendar.event.completion.info',
            },
        },
        header: {
            title: 'calendar.header.title',
        },
        event_details: {
            tabs: {
                informations: 'calendar.event_details.tabs.informations',
                agenda: 'calendar.event_details.tabs.agenda',
                files: 'calendar.event_details.tabs.files',
                tasks: 'calendar.event_details.tabs.tasks',
                resolutions: 'calendar.event_details.tabs.resolutions',
            },
            generateMinutesButton: 'calendar.event_details.generateMinutesButton',
            generateMinutesFrench: 'calendar.event_details.generateMinutesFrench',
            generateMinutesEnglish: 'calendar.event_details.generateMinutesEnglish',
            generateMinutesNL: 'calendar.event_details.generateMinutesNL',
        },
        future: 'calendar.future',
        past: 'calendar.past',
    },
    create_event: {
        placeholder: {
            title: 'create_event.placeholder.title',
            body: 'create_event.placeholder.body',
        },
        title: {
            length: {
                error: 'create_event.title.length.error',
            },
        },
    },
    poll: {
        voteResults: 'poll.voteResults',
        poll_title: 'poll.poll_title',
        poll_answers: {
            title: 'poll.poll_answers.title',
            answer: {
                input: 'poll.poll_answers.answer.input',
            },
            'add-answer': 'poll.poll_answers.add-answer',
        },
        poll_delete: 'poll.poll_delete',
        votes: {
            total: 'poll.votes.total',
            voted: 'poll.votes.voted',
        },
        vote: {
            change: 'poll.vote.change',
        },
    },
    voteResults: {
        pendingVotes: 'voteResults.pendingVotes',
    },
    member: {
        startDate: 'member.startDate',
    },
    invitation: {
        status: {
            expired: 'invitation.status.expired',
            pending: 'invitation.status.pending',
            notFoundOrAlreadyConfirmed: 'invitation.status.notFoundOrAlreadyConfirmed',
        },
        resend: {
            success: 'invitation.resend.success',
            error: 'invitation.resend.error',
        },
        delete: {
            success: 'invitation.delete.success',
            error: 'invitation.delete.error',
        },
        select_member_role: {
            error: 'invitation.select_member_role.error',
        },
        code: {
            received: 'invitation.code.received',
        },
        'phone-number': 'invitation.phone-number',
        'informative-text': 'invitation.informative-text',
        send: {
            'validation-code': 'invitation.send.validation-code',
        },
        'before-you-complete-your-profile': 'invitation.before-you-complete-your-profile',
        error: 'invitation.error',
        register: {
            language: {
                label: 'invitation.register.language.label',
            },
            'language-select': 'invitation.register.language-select',
            timezone: {
                label: 'invitation.register.timezone.label',
            },
            'timezone-select': 'invitation.register.timezone-select',
        },
        header: {
            title: 'invitation.header.title',
        },
        'self-onboarding': {
            header: {
                title: 'invitation.self-onboarding.header.title',
            },
        },
        auth: {
            'wrong-code-or-expired': 'invitation.auth.wrong-code-or-expired',
        },
        email: {
            title: 'invitation.email.title',
        },
        button: {
            title: 'invitation.button.title',
        },
        platformRole: {
            title: 'invitation.platformRole.title',
        },
    },
    add: {
        member: {
            invitation: {
                success: 'add.member.invitation.success',
                error: 'add.member.invitation.error',
                email: {
                    label: 'add.member.invitation.email.label',
                },
                resend: 'add.member.invitation.resend',
                invite: 'add.member.invitation.invite',
                'sent-to': 'add.member.invitation.sent-to',
                'deleted-for': 'add.member.invitation.deleted-for',
            },
        },
        member_already_exists: {
            invitation: {
                error: 'add.member_already_exists.invitation.error',
            },
        },
    },
    invite: {
        member: {
            title: 'invite.member.title',
            select_member_role: 'invite.member.select_member_role',
        },
        email_already_exist: {
            toast: {
                error: 'invite.email_already_exist.toast.error',
            },
        },
    },
    other_profile: {
        profile_informations: 'other_profile.profile_informations',
        no_bio_provided_placeholder: 'other_profile.no_bio_provided_placeholder',
        update_email_warning: 'other_profile.update_email_warning',
        update_email: 'other_profile.update_email',
        phone_updated_success: 'other_profile.phone_updated_success',
    },
    other_member: {
        govrn_user_until: 'other_member.govrn_user_until',
        update: {
            successfull: 'other_member.update.successfull',
            error: 'other_member.update.error',
        },
        suspend_user: 'other_member.suspend_user',
    },
    date: {
        no_date: {
            placeholder: 'date.no_date.placeholder',
        },
        no_time: {
            placeholder: 'date.no_time.placeholder',
        },
    },
    messages: {
        placeholder: 'messages.placeholder',
        createDiscussion: {
            title: 'messages.createDiscussion.title',
        },
        moduleDisabled: {
            title: 'messages.moduleDisabled.title',
            subtitle: 'messages.moduleDisabled.subtitle',
        },
        createNewGroup: {
            title: 'messages.createNewGroup.title',
        },
        groupName: {
            label: 'messages.groupName.label',
            placeholder: 'messages.groupName.placeholder',
            title: 'messages.groupName.title',
        },
        chatBox: {
            placeholder: 'messages.chatBox.placeholder',
            deleteMessagesButton: {
                label: 'messages.chatBox.deleteMessagesButton.label',
                enabled: {
                    label: 'messages.chatBox.deleteMessagesButton.enabled.label',
                },
            },
        },
        removed: {
            placeholder: {
                me: 'messages.removed.placeholder.me',
                other: 'messages.removed.placeholder.other',
            },
            title: 'messages.removed.title',
        },
        chat: {
            ephemeral: {
                banner: 'messages.chat.ephemeral.banner',
            },
            upload: {
                file: 'messages.chat.upload.file',
            },
            'group-admin': 'messages.chat.group-admin',
        },
        file: {
            placeholder: {
                me: 'messages.file.placeholder.me',
                other: 'messages.file.placeholder.other',
            },
        },
        post: {
            placeholder: {
                me: 'messages.post.placeholder.me',
                other: 'messages.post.placeholder.other',
            },
        },
        event: {
            placeholder: {
                me: 'messages.event.placeholder.me',
                other: 'messages.event.placeholder.other',
            },
        },
        startDiscussion: 'messages.startDiscussion',
        secure: 'messages.secure',
        viewed: 'messages.viewed',
        ephemeral: {
            view: 'messages.ephemeral.view',
        },
        message: {
            seenBy: 'messages.message.seenBy',
        },
        press_shift_enter: 'messages.press_shift_enter',
    },
    email: {
        empty: {
            error: 'email.empty.error',
        },
    },
    validation: {
        createGroupChannel: {
            name: {
                required: 'validation.createGroupChannel.name.required',
                minLength: 'validation.createGroupChannel.name.minLength',
            },
            participants: {
                minLength: 'validation.createGroupChannel.participants.minLength',
                minLength_1: 'validation.createGroupChannel.participants.minLength_1',
            },
        },
        signIn: {
            all: {
                invalid: 'validation.signIn.all.invalid',
            },
            email: {
                format: 'validation.signIn.email.format',
                required: 'validation.signIn.email.required',
            },
            password: {
                required: 'validation.signIn.password.required',
                length: 'validation.signIn.password.length',
            },
        },
        '2fa': {
            smsCode: {
                invalid: 'validation.2fa.smsCode.invalid',
            },
        },
        forgotPasswordCreatePassword: {
            newPassword: {
                required: 'validation.forgotPasswordCreatePassword.newPassword.required',
                length: 'validation.forgotPasswordCreatePassword.newPassword.length',
            },
            confirmNewPassword: {
                required: 'validation.forgotPasswordCreatePassword.confirmNewPassword.required',
                not_equal: 'validation.forgotPasswordCreatePassword.confirmNewPassword.not_equal',
            },
        },
        create_post: {
            errors: {
                generic: 'validation.create_post.errors.generic',
                invalid_file_extension: 'validation.create_post.errors.invalid_file_extension',
                message: {
                    required: 'validation.create_post.errors.message.required',
                },
                title: {
                    required: 'validation.create_post.errors.title.required',
                },
                poll: {
                    min: 'validation.create_post.errors.poll.min',
                },
            },
        },
        title: 'validation.title',
        start_date_and_hour: 'validation.start_date_and_hour',
        end_date_and_hour: 'validation.end_date_and_hour',
        create_event: {
            location: 'validation.create_event.location',
            timezone: 'validation.create_event.timezone',
            url: 'validation.create_event.url',
            event_type: 'validation.create_event.event_type',
        },
        create_task: {
            assignee: 'validation.create_task.assignee',
        },
        due_date: 'validation.due_date',
        login_in: {
            reset_password: 'validation.login_in.reset_password',
        },
        feed: {
            delete_message: {
                success: 'validation.feed.delete_message.success',
            },
            next_event: {
                error: 'validation.feed.next_event.error',
            },
            auto_sync_success: 'validation.feed.auto_sync_success',
        },
        enter_valid_email: 'validation.enter_valid_email',
        enter_a_message: 'validation.enter_a_message',
        sharing_content: {
            error: 'validation.sharing_content.error',
        },
        common: {
            enter_a_title: 'validation.common.enter_a_title',
            select_file_type: 'validation.common.select_file_type',
            error_occuried: 'validation.common.error_occuried',
        },
        events: {
            publish: {
                error: 'validation.events.publish.error',
            },
        },
        event_details: {
            event_invitation: 'validation.event_details.event_invitation',
        },
        message: {
            document: {
                error: 'validation.message.document.error',
            },
            error: 'validation.message.error',
        },
        document: {
            upload: {
                success: 'validation.document.upload.success',
                error: 'validation.document.upload.error',
            },
            download: {
                error: 'validation.document.download.error',
                success: 'validation.document.download.success',
            },
        },
        profile: {
            my_information: {
                first_name: 'validation.profile.my_information.first_name',
                last_name: 'validation.profile.my_information.last_name',
                nickname: 'validation.profile.my_information.nickname',
                language: 'validation.profile.my_information.language',
            },
        },
        company_form: {
            street_name: 'validation.company_form.street_name',
            city_name: 'validation.company_form.city_name',
            country: 'validation.company_form.country',
            culture_name: 'validation.company_form.culture_name',
            legal_name: 'validation.company_form.legal_name',
            zip_code: 'validation.company_form.zip_code',
            vat_id: 'validation.company_form.vat_id',
            state: 'validation.company_form.state',
        },
        end_date_before_start_date: {
            Error: 'validation.end_date_before_start_date.Error',
        },
        url: 'validation.url',
        sharing_event: {
            success: 'validation.sharing_event.success',
        },
    },
    private_chat: {
        placeholder: {
            title: 'private_chat.placeholder.title',
            subtitle: 'private_chat.placeholder.subtitle',
        },
        empty: {
            title: 'private_chat.empty.title',
        },
    },
    share_in_message: {
        page: {
            title: 'share_in_message.page.title',
            create_a_group: 'share_in_message.page.create_a_group',
        },
    },
    share_in_messages: {
        search: {
            placeholder: {
                empty: 'share_in_messages.search.placeholder.empty',
            },
        },
    },
    accept_leaving: {
        title: 'accept_leaving.title',
        content: 'accept_leaving.content',
        cta: {
            leave: 'accept_leaving.cta.leave',
            cancel: 'accept_leaving.cta.cancel',
        },
    },
    task_details: {
        completed: 'task_details.completed',
    },
    event_details: {
        agenda: {
            vote: {
                button: 'event_details.agenda.vote.button',
            },
        },
    },
    create_task: {
        add_an_option: 'create_task.add_an_option',
    },
    members: {
        invite: {
            email: {
                placeholder: 'members.invite.email.placeholder',
            },
        },
        suspend_member: 'members.suspend_member',
        tab_member: {
            title: 'members.tab_member.title',
        },
        tab_group: {
            title: 'members.tab_group.title',
        },
        tab_invitation: {
            title: 'members.tab_invitation.title',
        },
        filter: {
            show_all: 'members.filter.show_all',
            show_active: 'members.filter.show_active',
            show_inactive: 'members.filter.show_inactive',
        },
    },
    vote: {
        need_presence: {
            error: 'vote.need_presence.error',
        },
    },
    user_profile: {
        notifications: {
            alert_new_messages: 'user_profile.notifications.alert_new_messages',
            digest_email_with_summary: 'user_profile.notifications.digest_email_with_summary',
            daily: 'user_profile.notifications.daily',
            never: 'user_profile.notifications.never',
            on: 'user_profile.notifications.on',
            off: 'user_profile.notifications.off',
            weekly: 'user_profile.notifications.weekly',
        },
    },
    channel: {
        chatSettings: {
            title: 'channel.chatSettings.title',
            'group-photo': 'channel.chatSettings.group-photo',
            groupName: {
                label: 'channel.chatSettings.groupName.label',
                input: {
                    placeholder: 'channel.chatSettings.groupName.input.placeholder',
                },
            },
        },
        chat: {
            start: 'channel.chat.start',
            otherBoardMembers: 'channel.chat.otherBoardMembers',
        },
        header: {
            title: 'channel.header.title',
        },
    },
    chat_settings: {
        delete_group: 'chat_settings.delete_group',
    },
    edit_group_settings: {
        success: 'edit_group_settings.success',
        error: 'edit_group_settings.error',
    },
    delete_group: {
        success: 'delete_group.success',
    },
    sign: {
        instructions: {
            header: 'sign.instructions.header',
            body: {
                header: 'sign.instructions.body.header',
                first_rule: 'sign.instructions.body.first_rule',
                second_rule: 'sign.instructions.body.second_rule',
                thirth_rule: 'sign.instructions.body.thirth_rule',
                fourth_rule: 'sign.instructions.body.fourth_rule',
                fifth_rule: 'sign.instructions.body.fifth_rule',
            },
            button: {
                start_signature_process: 'sign.instructions.button.start_signature_process',
            },
            all: 'sign.instructions.all',
        },
        document: {
            details: {
                sign_header: 'sign.document.details.sign_header',
            },
            signed: 'sign.document.signed',
            canceled: 'sign.document.canceled',
            error: 'sign.document.error',
            expiration: 'sign.document.expiration',
            resend: 'sign.document.resend',
        },
        user_already_signed_document: 'sign.user_already_signed_document',
        go_to_document: 'sign.go_to_document',
    },
    document_viewer: {
        annotation: {
            update: {
                error: 'document_viewer.annotation.update.error',
            },
        },
        sign_reminder: {
            error: 'document_viewer.sign_reminder.error',
            success: 'document_viewer.sign_reminder.success',
        },
    },
    create_document: {
        added_members: {
            title: 'create_document.added_members.title',
            helper: 'create_document.added_members.helper',
        },
    },
    event: {
        detail: {
            title: 'event.detail.title',
        },
        presences: {
            change_your_status: 'event.presences.change_your_status',
        },
        create_event: {
            success: 'event.create_event.success',
        },
        update_event: {
            success: 'event.update_event.success',
        },
        card: {
            tasks_completed: 'event.card.tasks_completed',
            tasks_information: 'event.card.tasks_information',
        },
        details: {
            publish: {
                title: 'event.details.publish.title',
                subtitle: 'event.details.publish.subtitle',
            },
            tasks: {
                title: 'event.details.tasks.title',
                placeholder: {
                    title: 'event.details.tasks.placeholder.title',
                    subtitle: 'event.details.tasks.placeholder.subtitle',
                },
            },
            presence: {
                is_present: 'event.details.presence.is_present',
            },
            preview_minutes: {
                title: 'event.details.preview_minutes.title',
                view: 'event.details.preview_minutes.view',
                no_minutes: 'event.details.preview_minutes.no_minutes',
                regenerate: 'event.details.preview_minutes.regenerate',
                generate_tooltip: 'event.details.preview_minutes.generate_tooltip',
                confirm_regenerate_message: 'event.details.preview_minutes.confirm_regenerate_message',
                language_selection: 'event.details.preview_minutes.language_selection',
                admin_options: 'event.details.preview_minutes.admin_options',
                edit_tooltip: 'event.details.preview_minutes.edit_tooltip',
                edit: 'event.details.preview_minutes.edit',
                regenerate_tooltip: 'event.details.preview_minutes.regenerate_tooltip',
                not_available: 'event.details.preview_minutes.not_available',
                upload_tooltip: 'event.details.preview_minutes.upload_tooltip',
                upload: 'event.details.preview_minutes.upload',
                confirm_regenerate_title: 'event.details.preview_minutes.confirm_regenerate_title',
                minutes_available: 'event.details.preview_minutes.minutes_available',
            },
            'AI-summary': 'event.details.AI-summary',
            AI: {
                module: {
                    title: 'event.details.AI.module.title',
                    subtitle: 'event.details.AI.module.subtitle',
                },
                subject: 'event.details.AI.subject',
                placeholder: {
                    title: 'event.details.AI.placeholder.title',
                    title_not_recorded: 'event.details.AI.placeholder.title_not_recorded',
                    title_will_not_recorded: 'event.details.AI.placeholder.title_will_not_recorded',
                },
            },
            number_of_tasks: 'event.details.number_of_tasks',
            meeting_engagement: 'event.details.meeting_engagement',
            meeting_engagement_description: 'event.details.meeting_engagement_description',
            join_meeting: 'event.details.join_meeting',
        },
        common: {
            cancel: 'event.common.cancel',
            generate: 'event.common.generate',
        },
    },
    leave_workspace: {
        success_toast: 'leave_workspace.success_toast',
    },
    example: {
        joanna: 'example.joanna',
    },
    _ET_Audit: '_ET_Audit',
    _ET_BoardMeeting: '_ET_BoardMeeting',
    _ET_CEX: '_ET_CEX',
    _ET_Crisis: '_ET_Crisis',
    _ET_EC: '_ET_EC',
    _ET_Invest: '_ET_Invest',
    _ET_MonthlyUpdate: '_ET_MonthlyUpdate',
    _ET_Remco: '_ET_Remco',
    _ET_Strategic: '_ET_Strategic',
    _FT_BMRESUME: '_FT_BMRESUME',
    _FT_BOARDAGENDA: '_FT_BOARDAGENDA',
    _FT_BOARDAPPE: '_FT_BOARDAPPE',
    _FT_BOARDDECK: '_FT_BOARDDECK',
    _FT_BOARDMINUTE: '_FT_BOARDMINUTE',
    _FT_BOARDVOTING: '_FT_BOARDVOTING',
    _FT_BYLAW: '_FT_BYLAW',
    _FT_CapTable: '_FT_CapTable',
    _FT_CompanyFile: '_FT_CompanyFile',
    _FT_CompanyLogo: '_FT_CompanyLogo',
    _FT_DiscussFile: '_FT_DiscussFile',
    _FT_PostFile: '_FT_PostFile',
    _FT_ProfilePicture: '_FT_ProfilePicture',
    _FT_SHA: '_FT_SHA',
    invitate: {
        member: {
            select_member_role: 'invitate.member.select_member_role',
            title: 'invitate.member.title',
        },
    },
    boardEvaluation: {
        title: 'boardEvaluation.title',
        survey: {
            submit: 'boardEvaluation.survey.submit',
            rating: {
                one: 'boardEvaluation.survey.rating.one',
                two: 'boardEvaluation.survey.rating.two',
                three: 'boardEvaluation.survey.rating.three',
                four: 'boardEvaluation.survey.rating.four',
                extremelySatisfied: 'boardEvaluation.survey.rating.extremelySatisfied',
            },
        },
        common: {
            survey: {
                status: {
                    draft: 'boardEvaluation.common.survey.status.draft',
                    published: 'boardEvaluation.common.survey.status.published',
                    closed: 'boardEvaluation.common.survey.status.closed',
                },
            },
            participants: 'boardEvaluation.common.participants',
            current: 'boardEvaluation.common.current',
            target: 'boardEvaluation.common.target',
            deadline: 'boardEvaluation.common.deadline',
            aligned: 'boardEvaluation.common.aligned',
            slightlyMisaligned: 'boardEvaluation.common.slightlyMisaligned',
            misaligned: 'boardEvaluation.common.misaligned',
            fullyMisaligned: 'boardEvaluation.common.fullyMisaligned',
            submissions: 'boardEvaluation.common.submissions',
            alignment: 'boardEvaluation.common.alignment',
            rating: 'boardEvaluation.common.rating',
        },
        edit: {
            error: {
                noParticipant: 'boardEvaluation.edit.error.noParticipant',
            },
        },
        overview: {
            surveyBox: {
                menu: {
                    edit: 'boardEvaluation.overview.surveyBox.menu.edit',
                    results: 'boardEvaluation.overview.surveyBox.menu.results',
                    delete: 'boardEvaluation.overview.surveyBox.menu.delete',
                },
                action: {
                    edit: 'boardEvaluation.overview.surveyBox.action.edit',
                    take: 'boardEvaluation.overview.surveyBox.action.take',
                    results: 'boardEvaluation.overview.surveyBox.action.results',
                    taken: {
                        not: 'boardEvaluation.overview.surveyBox.action.taken.not',
                    },
                },
            },
            emptyState: {
                title: 'boardEvaluation.overview.emptyState.title',
                subTitle: 'boardEvaluation.overview.emptyState.subTitle',
                callToAction: 'boardEvaluation.overview.emptyState.callToAction',
            },
        },
        methodology: {
            title: 'boardEvaluation.methodology.title',
            callToAction: 'boardEvaluation.methodology.callToAction',
            list: 'boardEvaluation.methodology.list',
        },
    },
    dashboard: {
        header: {
            title: 'dashboard.header.title',
        },
        'collective-intelligence-index': 'dashboard.collective-intelligence-index',
        'sessions-and-users': 'dashboard.sessions-and-users',
        'session-length-average': 'dashboard.session-length-average',
        'action-age-average': 'dashboard.action-age-average',
        'performed-actions': 'dashboard.performed-actions',
        'used-features': 'dashboard.used-features',
    },
    page: {
        menu: {
            'news-feed': 'page.menu.news-feed',
            actions: 'page.menu.actions',
            calendar: 'page.menu.calendar',
            chat: 'page.menu.chat',
        },
    },
    surveyDetector: {
        message: 'surveyDetector.message',
    },
    updateAvailableDetector: {
        reloadMessage: 'updateAvailableDetector.reloadMessage',
    },
    'self-onboarding': {
        welcome: 'self-onboarding.welcome',
        email: {
            label: 'self-onboarding.email.label',
        },
        'company-name': {
            label: 'self-onboarding.company-name.label',
        },
        'legal-form': {
            label: 'self-onboarding.legal-form.label',
        },
        street: {
            label: 'self-onboarding.street.label',
        },
        street2: {
            label: 'self-onboarding.street2.label',
        },
        'zip-code': {
            label: 'self-onboarding.zip-code.label',
        },
        state: {
            label: 'self-onboarding.state.label',
        },
        city: {
            label: 'self-onboarding.city.label',
        },
        country: {
            label: 'self-onboarding.country.label',
        },
        'general-terms-and-conditions': 'self-onboarding.general-terms-and-conditions',
        instruction: 'self-onboarding.instruction',
        'next-board-meeting': {
            label: 'self-onboarding.next-board-meeting.label',
        },
    },
    _FT_PROXY_TEMPLATE: '_FT_PROXY_TEMPLATE',
    '_Proxy document {0}': '_Proxy document {0}',
    '_Welcome in your new board Stream!': '_Welcome in your new board Stream!',
    '{0} {1} just joined {2}!  Welcome {3}!': '{0} {1} just joined {2}!  Welcome {3}!',
    _FT_PROXY: '_FT_PROXY',
    'en-GB': 'en-GB',
    'fr-FR': 'fr-FR',
    'nl-NL': 'nl-NL',
    select_people: {
        placeholder: {
            title: 'select_people.placeholder.title',
            subtitle: 'select_people.placeholder.subtitle',
        },
    },
    manage_files: {
        placeholder: {
            title: 'manage_files.placeholder.title',
            subtitle: 'manage_files.placeholder.subtitle',
        },
    },
    manage_events: {
        placeholder: {
            title: 'manage_events.placeholder.title',
            subtitle: 'manage_events.placeholder.subtitle',
        },
    },
    repository: {
        placeholder: {
            title: 'repository.placeholder.title',
            subtitle: 'repository.placeholder.subtitle',
        },
        order: {
            last_issued_on_first: 'repository.order.last_issued_on_first',
            last_issued_on_last: 'repository.order.last_issued_on_last',
        },
        create_document: {
            alert: {
                no_event: 'repository.create_document.alert.no_event',
                event: 'repository.create_document.alert.event',
            },
        },
    },
    channels: {
        placeholder: {
            title: 'channels.placeholder.title',
            subtitle: 'channels.placeholder.subtitle',
        },
        search: {
            placeholder: {
                title: 'channels.search.placeholder.title',
                subtitle: 'channels.search.placeholder.subtitle',
            },
        },
    },
    languages: {
        french: 'languages.french',
        dutch: 'languages.dutch',
        english: 'languages.english',
        spanish: 'languages.spanish',
    },
    inviteBanner: {
        Title: 'inviteBanner.Title',
        subTitle: 'inviteBanner.subTitle',
        button: 'inviteBanner.button',
    },
    eventWidget: {
        Title: 'eventWidget.Title',
        empty: {
            title: 'eventWidget.empty.title',
            subTitle: 'eventWidget.empty.subTitle',
            cta: 'eventWidget.empty.cta',
        },
    },
    discussionWidget: {
        empty: {
            title: 'discussionWidget.empty.title',
            subTitle: 'discussionWidget.empty.subTitle',
            cta: 'discussionWidget.empty.cta',
        },
        title: 'discussionWidget.title',
    },
    widget: {
        common: {
            redirect: 'widget.common.redirect',
        },
    },
    actionWidget: {
        title: 'actionWidget.title',
    },
    Yes: 'Yes',
    No: 'No',
    NoOpinion: 'NoOpinion',
    toast: {
        offline: {
            redirect: {
                text1: 'toast.offline.redirect.text1',
                text2: 'toast.offline.redirect.text2',
            },
        },
        online: {
            redirect: {
                text1: 'toast.online.redirect.text1',
                text2: 'toast.online.redirect.text2',
            },
        },
    },
    document_details: {
        sync_tag: {
            sync: 'document_details.sync_tag.sync',
            not_sync: 'document_details.sync_tag.not_sync',
        },
    },
    offline_repository: {
        section: {
            title: 'offline_repository.section.title',
        },
    },
    sign_up: {
        account_informations: {
            title: 'sign_up.account_informations.title',
        },
        already_confirmed: {
            alert: 'sign_up.already_confirmed.alert',
        },
    },
    homepage: {
        title: 'homepage.title',
        hello: 'homepage.hello',
        description: 'homepage.description',
        task_to_be_completed: 'homepage.task_to_be_completed',
        placeholder: {
            title: 'homepage.placeholder.title',
            board_admin: {
                subtitle: 'homepage.placeholder.board_admin.subtitle',
            },
            board_member: {
                subtitle: 'homepage.placeholder.board_member.subtitle',
            },
        },
        see_all_events: 'homepage.see_all_events',
        next_events: {
            title: 'homepage.next_events.title',
        },
        see_all_tasks: 'homepage.see_all_tasks',
        emptyState: {
            title: 'homepage.emptyState.title',
            description: 'homepage.emptyState.description',
            createGroup: 'homepage.emptyState.createGroup',
            createGroupDescription: 'homepage.emptyState.createGroupDescription',
            createEvent: 'homepage.emptyState.createEvent',
            createEventDescription: 'homepage.emptyState.createEventDescription',
            addDocuments: 'homepage.emptyState.addDocuments',
            addDocumentsDescription: 'homepage.emptyState.addDocumentsDescription',
            inviteMembers: 'homepage.emptyState.inviteMembers',
            inviteMembersDescription: 'homepage.emptyState.inviteMembersDescription',
        },
    },
    platform: {
        role: {
            board_admin: {
                description: 'platform.role.board_admin.description',
            },
            board_member: {
                description: 'platform.role.board_member.description',
            },
            board_observer: {
                description: 'platform.role.board_observer.description',
            },
        },
    },
    _BR_Chairman: '_BR_Chairman',
    _BR_CEO: '_BR_CEO',
    _BR_CFO: '_BR_CFO',
    _BR_IndependentDirectors: '_BR_IndependentDirectors',
    _BR_CorporateSecretaries: '_BR_CorporateSecretaries',
    _BR_GeneralCounsel: '_BR_GeneralCounsel',
    _BR_DigitalExecutives: '_BR_DigitalExecutives',
    agenda_item: {
        type: {
            title: 'agenda_item.type.title',
        },
        documents: {
            information: 'agenda_item.documents.information',
            modal: {
                title: 'agenda_item.documents.modal.title',
            },
            placeholder: {
                title: 'agenda_item.documents.placeholder.title',
                subtitle: 'agenda_item.documents.placeholder.subtitle',
            },
            dragzone: {
                browse_or_drag: 'agenda_item.documents.dragzone.browse_or_drag',
            },
        },
        timing: {
            information: 'agenda_item.timing.information',
        },
        sub_agenda_item: {
            add: 'agenda_item.sub_agenda_item.add',
        },
        drop_in_first: 'agenda_item.drop_in_first',
        delete_confirmation: {
            title: 'agenda_item.delete_confirmation.title',
        },
        main_agenda_item: {
            add: 'agenda_item.main_agenda_item.add',
        },
    },
    groups: {
        placeholder: {
            no_groups: 'groups.placeholder.no_groups',
            title: 'groups.placeholder.title',
            subtitle_member: 'groups.placeholder.subtitle_member',
            subtitle_admin: 'groups.placeholder.subtitle_admin',
        },
        add: 'groups.add',
        edit: 'groups.edit',
        allow_historical_data: 'groups.allow_historical_data',
        delete: {
            success: 'groups.delete.success',
            error: 'groups.delete.error',
        },
        members_number: 'groups.members_number',
    },
    permissions: {
        placeholder: {
            title: 'permissions.placeholder.title',
            subtitle: 'permissions.placeholder.subtitle',
        },
    },
    sign_in: {
        extension: {
            title: 'sign_in.extension.title',
            subtitle: 'sign_in.extension.subtitle',
        },
        no_account_invitation: 'sign_in.no_account_invitation',
    },
    enrolment_selection: {
        title: 'enrolment_selection.title',
        company_selector: {
            placeholder: 'enrolment_selection.company_selector.placeholder',
        },
    },
    export: {
        title: 'export.title',
        document_type_selector: {
            placeholder: 'export.document_type_selector.placeholder',
        },
        list: {
            event_selector: {
                placeholder: 'export.list.event_selector.placeholder',
            },
            agenda_item_selector: {
                placeholder: 'export.list.agenda_item_selector.placeholder',
            },
            duplicate_selector: {
                placeholder: 'export.list.duplicate_selector.placeholder',
            },
            duplicate: {
                alert: 'export.list.duplicate.alert',
            },
            alert: 'export.list.alert',
        },
        alert: 'export.alert',
        button: {
            title: 'export.button.title',
        },
        succes: {
            title: 'export.succes.title',
            subtitle: 'export.succes.subtitle',
        },
    },
    delete_confirmation_modal: {
        title: 'delete_confirmation_modal.title',
        subtitle: 'delete_confirmation_modal.subtitle',
    },
    boardpack: {
        page: {
            title: 'boardpack.page.title',
            cta: {
                download_all: 'boardpack.page.cta.download_all',
            },
        },
        download: {
            toast: 'boardpack.download.toast',
        },
    },
    board_pack: {
        informations: 'board_pack.informations',
        placeholder: {
            title: 'board_pack.placeholder.title',
        },
    },
    'es-ES': 'es-ES',
    agenda_items: {
        view_board_pack: 'agenda_items.view_board_pack',
    },
    documents: {
        no_event_linked: 'documents.no_event_linked',
    },
    share_event: {
        tabs: {
            chat: 'share_event.tabs.chat',
            email: 'share_event.tabs.email',
        },
        email: {
            chat: 'share_event.email.chat',
            title: 'share_event.email.title',
            list: {
                calendar: 'share_event.email.list.calendar',
                basic_info: 'share_event.email.list.basic_info',
                agenda: 'share_event.email.list.agenda',
                documents_link: 'share_event.email.list.documents_link',
            },
            not_published: 'share_event.email.not_published',
        },
    },
    global: {
        search: {
            title: 'global.search.title',
            description: 'global.search.description',
            input: {
                placeholder: 'global.search.input.placeholder',
            },
            menu: {
                title: 'global.search.menu.title',
            },
        },
    },
    engagement: {
        tasksComplete: 'engagement.tasksComplete',
        notRSVPd: 'engagement.notRSVPd',
    },
    minutes: {
        header: 'minutes.header',
        present: 'minutes.present',
        participated: 'minutes.participated',
        in: {
            person: 'minutes.in.person',
        },
        by: {
            conference: 'minutes.by.conference',
        },
        represented: {
            by: 'minutes.represented.by',
        },
        holder: {
            of: {
                signed: {
                    proxy: 'minutes.holder.of.signed.proxy',
                },
            },
        },
        absent: 'minutes.absent',
        validity: {
            of: {
                meeting: 'minutes.validity.of.meeting',
            },
        },
        all: {
            directors: {
                present: 'minutes.all.directors.present',
            },
        },
        not: {
            all: {
                directors: {
                    present: 'minutes.not.all.directors.present',
                },
            },
        },
        agenda: {
            of: {
                meeting: 'minutes.agenda.of.meeting',
            },
        },
        resolutions: 'minutes.resolutions',
        board: {
            unanimously: {
                resolves: 'minutes.board.unanimously.resolves',
            },
        },
        list: {
            of: {
                actions: 'minutes.list.of.actions',
                annexes: 'minutes.list.of.annexes',
            },
        },
        annex: 'minutes.annex',
        convening: {
            notices: 'minutes.convening.notices',
        },
        proxies: 'minutes.proxies',
        editor: {
            export_docx: 'minutes.editor.export_docx',
            toolbar: {
                bold: 'minutes.editor.toolbar.bold',
                heading2: 'minutes.editor.toolbar.heading2',
                italic: 'minutes.editor.toolbar.italic',
                decrease_indent: 'minutes.editor.toolbar.decrease_indent',
                increase_indent: 'minutes.editor.toolbar.increase_indent',
                heading1: 'minutes.editor.toolbar.heading1',
                heading3: 'minutes.editor.toolbar.heading3',
                bullet_list: 'minutes.editor.toolbar.bullet_list',
                numbered_list: 'minutes.editor.toolbar.numbered_list',
            },
            saved: 'minutes.editor.saved',
            export_pdf: 'minutes.editor.export_pdf',
            saving: 'minutes.editor.saving',
            save_button: 'minutes.editor.save_button',
        },
        sidebar: {
            template: {
                attendance_record: 'minutes.sidebar.template.attendance_record',
                action_items: 'minutes.sidebar.template.action_items',
                attendance_record_content: 'minutes.sidebar.template.attendance_record_content',
                meeting_opening: 'minutes.sidebar.template.meeting_opening',
                insert: 'minutes.sidebar.template.insert',
                action_items_content: 'minutes.sidebar.template.action_items_content',
                previous_minutes: 'minutes.sidebar.template.previous_minutes',
                previous_minutes_content: 'minutes.sidebar.template.previous_minutes_content',
                type: 'minutes.sidebar.template.type',
                meeting_opening_content: 'minutes.sidebar.template.meeting_opening_content',
            },
            contact_support: 'minutes.sidebar.contact_support',
            no_summary_available: 'minutes.sidebar.no_summary_available',
            ai_generated_badge: 'minutes.sidebar.ai_generated_badge',
            meeting_info: {
                agenda: 'minutes.sidebar.meeting_info.agenda',
                location: 'minutes.sidebar.meeting_info.location',
                attendees: 'minutes.sidebar.meeting_info.attendees',
            },
        },
        builder: {
            download_docx: 'minutes.builder.download_docx',
            publish: 'minutes.builder.publish',
            minutes_title: 'minutes.builder.minutes_title',
        },
    },
    profile_informations: 'profile_informations',
};
